import { HOURLY, MONTHLY, ANNUAL } from '@/lib/constants/billRateTypes'
import { getTotalPayRate } from './payRateCalculator'

export function getNetBillRate (vmsFee, billRate) {
  return billRate - (billRate * (vmsFee / 100))
}

export function convertBillRate (billRate, currentBillRateType, desiredBillRateType, workedHoursAverage) {
  switch (desiredBillRateType) {
    case HOURLY:
      return getHourlyBillRate(billRate, currentBillRateType, workedHoursAverage)
    case MONTHLY:
      return getMonthlyBillRate(billRate, currentBillRateType, workedHoursAverage)
    case ANNUAL:
      return getAnnualBillRate(billRate, currentBillRateType, workedHoursAverage)
  }
}

export function getHourlyBillRate (billRate, billRateType, workedHoursAverage) {
  switch (billRateType) {
    case HOURLY:
      return billRate
    case MONTHLY:
      return billRate / workedHoursAverage
    case ANNUAL:
      return (billRate / 12) / workedHoursAverage
  }
}

export function getMonthlyBillRate (billRate, billRateType, workedHoursAverage) {
  switch (billRateType) {
    case HOURLY:
      return billRate * workedHoursAverage
    case MONTHLY:
      return billRate
    case ANNUAL:
      return billRate / 12
  }
}

export function getAnnualBillRate (billRate, billRateType, workedHoursAverage) {
  switch (billRateType) {
    case HOURLY:
      return (billRate * workedHoursAverage) * 12
    case MONTHLY:
      return billRate * 12
    case ANNUAL:
      return billRate
  }
}

export function getHourlyNetBillRate (vmsFee, billRate, billRateType, workedHoursAverage) {
  return getNetBillRate(vmsFee, getHourlyBillRate(billRate, billRateType, workedHoursAverage))
}

export function getMonthlyNetBillRate (vmsFee, billRate, billRateType, workedHoursAverage) {
  return getNetBillRate(vmsFee, getMonthlyBillRate(billRate, billRateType, workedHoursAverage))
}

export function getAnnualNetBillRate (vmsFee, billRate, billRateType, workedHoursAverage) {
  return getNetBillRate(vmsFee, getAnnualBillRate(billRate, billRateType, workedHoursAverage))
}

export function calculateBillRate (grossProfit, payRate, overheadPercent, vmsFee) {
  return (grossProfit + getTotalPayRate(overheadPercent, payRate)) / (1 - (vmsFee / 100))
}
